import axios from 'axios'
import { request2, baseURL2 } from '@/utils/httpClient'
import { processErrorResponse } from '@/utils/apiErrorMessages'
import i18n from '@/i18n'
import { DEFAULT_LOCALE } from '@/i18n/config'
import { getAuthHeaders } from './requestHelpers'

export const fetchWalletSummary = () => {
  return request2({
    url: '/api/wallets/me',
    method: 'GET',
    headers: getAuthHeaders()
  })
}

// 分页查询金币流水

export const fetchCoinTransactions = (params) => {
  return request2({
    url: '/api/wallets/me/coin-transactions',
    method: 'GET',
    headers: getAuthHeaders(),
    params
  })
}

// 创建钱包订单

export const createOrder = ({ idempotencyKey, type, typeId, quotaType, quotaUnits, batchKey }) => {
  const formData = new FormData()
  formData.append('idempotencyKey', idempotencyKey)
  formData.append('type', type)
  formData.append('typeId', typeId)
  if (quotaType) {
    formData.append('quotaType', quotaType)
  }
  if (quotaUnits !== undefined && quotaUnits !== null) {
    formData.append('quotaUnits', String(quotaUnits))
  }
  // 批次标识：同一次批量出图的每台相机各建一单，后端靠它豁免 E317 单飞限制。
  if (batchKey) {
    formData.append('batchKey', String(batchKey))
  }

  return request2({
    url: '/api/orders',
    method: 'POST',
    data: formData,
    headers: getAuthHeaders()
  })
}

// 查询订单详情

export const fetchOrderDetail = (orderId) => {
  return request2({
    url: '/api/orders',
    method: 'GET',
    headers: getAuthHeaders(),
    params: {
      orderId
    }
  })
}

// 分页查询订单列表

export const fetchOrderList = (params) => {
  return request2({
    url: '/api/order-list',
    method: 'GET',
    headers: getAuthHeaders(),
    params
  })
}

// 下载订单发票

export const downloadOrderInvoice = async (idempotencyKey) => {
  const instance = axios.create({ baseURL: baseURL2 })

  let currentLang = localStorage.getItem('lang')
  if (!currentLang) {
    currentLang = JSON.stringify(DEFAULT_LOCALE)
  }
  let language = 'en'
  try {
    language = JSON.parse(currentLang)
  } catch (e) {
    // ignore
  }

  const res = await instance({
    url: '/api/orders/invoice',
    method: 'POST',
    params: { idempotencyKey },
    responseType: 'blob',
    headers: getAuthHeaders({ language }),
    validateStatus: () => true,
  })

  const contentType = (res.headers && (res.headers['content-type'] || res.headers['Content-Type'])) || ''

  if (res.status === 401) {
    /** @type {any} */
    const err = new Error('Unauthorized')
    err.status = 401
    throw err
  }

  if (contentType.includes('application/json') || contentType.includes('text/json')) {
    const text = await res.data.text()
    let payload = {}
    try {
      payload = JSON.parse(text)
    } catch (e) {
      payload = { msg: text, status: res.status }
    }
    const processed = processErrorResponse(payload, (key) => {
      try {
        return i18n.t(key)
      } catch (e2) {
        return null
      }
    })
    /** @type {any} */
    const err = new Error(processed.localizedMsg || processed.msg || 'Invoice download failed')
    err.errorCode = processed.errorCode
    err.payload = processed
    throw err
  }

  if (res.status < 200 || res.status >= 300) {
    /** @type {any} */
    const err = new Error('Invoice download failed')
    err.status = res.status
    throw err
  }

  const disposition = res.headers && (res.headers['content-disposition'] || res.headers['Content-Disposition'])
  let filename = 'invoice.pdf'
  if (disposition) {
    const utf8Match = /filename\*=UTF-8''([^;]+)/i.exec(disposition)
    if (utf8Match && utf8Match[1]) {
      try {
        filename = decodeURIComponent(utf8Match[1].trim())
      } catch (e) {
        filename = utf8Match[1].trim()
      }
    } else {
      const plainMatch = /filename="?([^";]+)"?/i.exec(disposition)
      if (plainMatch && plainMatch[1]) {
        filename = plainMatch[1].trim()
      }
    }
  }

  return { blob: res.data, filename }
}

// 查询可购买套餐列表

export const fetchPackagesList = (params) => {
  return request2({
    url: '/api/packages-list',
    method: 'GET',
    headers: getAuthHeaders(),
    params
  })
}

// 查询当前用户订阅信息

export const fetchSubscriptionMe = () => {
  return request2({
    url: '/api/subscription/me',
    method: 'GET',
    headers: getAuthHeaders()
  })
}

// 查询支付配置开关

export const fetchPaymentConfig = () => {
  return request2({
    url: '/api/payment/config',
    method: 'GET'
  })
}

// 创建订阅订单

export const subscribeSubscription = (idempotencyKey, planId, campaignCode = '') => {
  const data = {
    idempotencyKey,
    planId
  }
  if (campaignCode) {
    data.campaignCode = campaignCode
  }
  return request2({
    url: '/api/subscription/subscribe',
    method: 'POST',
    headers: getAuthHeaders({
      'Content-Type': 'application/json'
    }),
    data
  })
}

export const validateSubscriptionCampaignCode = (codeText) => {
  return request2({
    url: '/api/campaign-code/subscription/validate',
    method: 'POST',
    headers: getAuthHeaders({
      'Content-Type': 'application/json'
    }),
    data: {
      codeText
    }
  })
}
